Vue.component('result-row', {
    props: ['result'],
    data() {
        return {
            isOpen : false,
        }
    },
    computed: {
        rowColor() {
            let score = this.result.contribution;
            if (score <=5) {
                return null;
            }
            if (score > 5 && score <= 10) {
                return '#fdfbd0';
            }
            if (score > 10 && score <= 20) {
                return '#fdeed3';
            }

            return '#fde0d5';
        }
    },
    methods: {

    },
    mounted() {
        //
    },
    template: `
        <tbody>
            <tr @click="isOpen = !isOpen" class="cursor-pointer" :style="{ backgroundColor: rowColor }">
                <td style="width: 10%"><img :src="'/images/icons/'+ result.impact_driver.icon_name +'.svg'" width="40"></td>
                <td style="width: 40%" class="align-middle">{{ result.impact_driver.name }}</td>
                <td style="width: 20%" class="align-middle"><span class="text-muted">≈</span> {{ result.total | result }} species•yr</td>
                <td style="width: 20%" class="align-middle">{{ result.contribution | percentage }}</td>
                <td style="width: 10%" class="align-middle"><i class="fa" :class="{'fa-chevron-down' : !isOpen, 'fa-chevron-up' : isOpen}"></i></td>
            </tr>
            <tr v-if="isOpen">
                <td colspan="5" class="p-0">
                    <table class="table subtable mb-0">
                        <tr>
                            <th style="width: 10%">
                            <th>Commodity</th>
                            <th>Approximate Impact</th>
                            <th>Contribution by commodity</th>
                        </tr>
                        <tr v-for="commodityData in result.commodity_data">
                            <td style="width: 10%"></td>
                            <td style="width: 40%">{{ commodityData.commodity }} <span class="text-muted">from/in</span> {{ commodityData.country }}</td>
                            <td style="width: 20%"><span class="text-muted">≈</span> {{ commodityData.impact | result }} species•yr</td>
                            <td style="width: 30%">{{ commodityData.impact/result.total*100 | percentage }}</td>
                        </tr>
                    </table>
                </td>
            </tr>
        </tbody>
    `
});